import React, { useState } from 'react';
import './DishCard.css';

const PlusIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
        <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
    </svg>
);

/** Iniciales a partir del nombre: "Rollos de Pollo" -> "RP" */
function toInitials(name = '') {
    return name.trim().split(/\s+/).slice(0, 2).map((w) => w[0] || '').join('').toUpperCase() || 'SP';
}

/**
 * DishCard — tarjeta de producto del menú (POS Smart Pay).
 *
 * Props:
 * @param {string}  name         Nombre del producto (requerido).
 * @param {number|string} price  Precio (se muestra como "$ price").
 * @param {string} [image]       URL de la imagen. Si falla o no hay, muestra iniciales.
 * @param {string} [category]    Categoría / subtítulo.
 * @param {string} [initials]    Texto de respaldo (si no, se deriva del nombre).
 * @param {'compact'|'photo'} [variant='compact']  Layout: fila compacta o galería con foto.
 * @param {boolean} [inCart=false]   Resalta la tarjeta y el botón (ya está en la orden).
 * @param {string}  [currency='$']   Símbolo de moneda.
 * @param {boolean} [disabled=false]
 * @param {(e)=>void} [onAdd]     Click en el botón (+). Detiene la propagación.
 * @param {(e)=>void} [onClick]   Click en la tarjeta (abrir producto/opciones).
 * @param {React.ReactNode} [addIcon]  Reemplaza el ícono del botón (+).
 * @param {string} [className]
 */
export function DishCard({
    name,
    price,
    points_id,
    points_value,
    pointsMenuEnabled,
    formatProductPoints,
    formatProductPrice,
    image,
    category,
    hidden,
    initials,
    variant = 'compact',
    inCart = false,
    currency = '$',
    disabled = false,
    onAdd,
    onClick,
    addIcon,
    className = '',
    ...rest



}) {
    const [imgFailed, setImgFailed] = useState(false);
    const init = initials || toInitials(name);
    const showImg = image && !imgFailed;
    const isPhoto = variant === 'photo';

    const handleCardClick = (e) => { if (!disabled) onClick?.(e); };
    const handleCardKey = (e) => {
        if (disabled || !onClick) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(e); }
    };
    const handleAdd = (e) => { e.stopPropagation(); if (!disabled) onAdd?.(e); };

    const classes = [
        'sp-dish',
        isPhoto ? 'sp-dish--photo' : 'sp-dish--compact',
        inCart && 'is-in-cart',
        disabled && 'is-disabled',
        className,
    ].filter(Boolean).join(' ');

    const foot = (
        <div className="sp-dish__foot">
            <span className="sp-dish__price">
                {/* {currency} */}

                {points_id ? (
                    pointsMenuEnabled
                        ? <>{formatProductPoints(points_value)} pts</>
                        : <>${formatProductPrice(price.toFixed(2))}</>
                ) : <></>}
            </span>







            <button
                type="button"
                className="sp-dish__add sp-focusable"
                onClick={handleCardClick}
                disabled={disabled}
                aria-label={`Agregar ${name}`}
            >
                {addIcon || PlusIcon}
            </button>
        </div>
    );

    return (
        <div
            className={classes}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick && !disabled ? 0 : undefined}
            aria-disabled={disabled || undefined}
            onClick={handleCardClick}
            onKeyDown={handleCardKey}
            {...rest}
        >
            {isPhoto ? (
                <>
                    <div className="sp-dish__media">
                        <div className="sp-dish__fallback" aria-hidden="true">{init}</div>
                        {showImg && (
                            <>
                                {!hidden ? <> <img className="sp-dish__img" src={image} alt={name} /></> : <></>}
                            </>
                        )}
                    </div>
                    <div className="sp-dish__body">
                        <div className="sp-dish__name">{name}</div>
                        {category && <div className="sp-dish__cat">{category}</div>}
                        {foot}
                    </div>
                </>
            ) : (
                <>
                    <div className="sp-dish__top">
                        {
                            showImg
                                ? <>
                                    {!hidden ? <><img className="sp-dish__thumb" src={image} alt={name} onError={() => setImgFailed(true)} /></> : <></>}
                                </>
                                : <>
                                    {!hidden ? <>  <div className="sp-dish__ph" aria-hidden="true">{init}</div></> : <></>}
                                </>
                        }
                        <div className="sp-dish__meta">
                            <div className="sp-dish__name">{name}</div>
                            {category && <div className="sp-dish__cat">{category}</div>}
                        </div>
                    </div>
                    {foot}
                </>
            )}
        </div>
    );
}

export default DishCard;